import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IVendorPayoffsData } from '../../../types/vendorDashboard/IVendorPayoffs';
import { ISearchOrdersSettingsData } from '../../../types/vendorDashboard/ISearchOrdersSettingsData';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { vendorPayoffsInitialState } from './interfaces';

export const vendorPayoffsReducer = createSlice({
  name: 'vendorPayoffs',
  initialState: vendorPayoffsInitialState,
  reducers: {
    setVendorPayoffsDataAction: (state, action: PayloadAction<IVendorPayoffsData>) => {
      state.payoffs = action.payload;
    },
    setSearchPayoffsSettingsAction: (state, action: PayloadAction<ISearchOrdersSettingsData>) => {
      state.searchSettings = action.payload;
    },
    setVendorPayoffsFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.payoffsFetchStatus = action.payload;
    },
    setVendorPayoffsErrorAction: (state, action: PayloadAction<string | undefined>) => {
      state.payoffsError = action.payload;
    },
  },
});
export const {
  setVendorPayoffsDataAction,
  setSearchPayoffsSettingsAction,
  setVendorPayoffsFetchStatusAction,
  setVendorPayoffsErrorAction,
} = vendorPayoffsReducer.actions;
